import { Component, inject, Input } from '@angular/core';
import { CreatorResponseDto } from '../../../../common/general-types/creators.dto';
import { ImageService } from '../../../../services/image/image.service';
import { FormatService } from '../../../../common/format/format.service';
import { MagicSearchService } from '../../service/magic-search/magic-search.service';
import { LdgImgComponent } from '../../../../atoms/ldg-img/ldg-img.component';
import { ShortNumberPipe } from '../../../../common/pipes/short-number/short-number.pipe';
import { CollaboratorService } from '../../../../services/collaborator/collaborator.service';
import { DecimalPipe } from '@angular/common';
import { SocialScreeningService } from '../../../../services/social-screening/social-screening.service';

@Component({
  selector: 'cc-creator-column-generic',
  standalone: true,
  imports: [LdgImgComponent, ShortNumberPipe, DecimalPipe],
  templateUrl: './creator-column-generic.component.html',
  styleUrl: './creator-column-generic.component.css'
})
export class CreatorColumnGenericComponent {

  @Input() creator!: any | CreatorResponseDto;
  @Input() showPartial: boolean = false;
  @Input() showAbout: boolean = true;
  @Input() searchColour: 'pink' | 'blue' | 'purple' | undefined;

  /** Services  */
  public imageService = inject(ImageService);
  public formatService = inject(FormatService);
  magicSearchService = inject(MagicSearchService);
  public collaboratorsService = inject(CollaboratorService);
  public socialScreeningService = inject(SocialScreeningService);
  /** Services - END */

  launchPortfolio() {
    this.magicSearchService.portfolioCreatorId.set(this.creator.blazeFirebaseUid);
    this.magicSearchService.portfolioCreator.set(this.creator);
  }

  getAverageViews() {
    if (this.creator && this.creator.ssCreator) {
      if (this.creator.ssCreator.instagramAverages && this.creator.ssCreator.tiktokAverages) {
        return ((this.creator.ssCreator.instagramAverages?.averageViews || 0) + (this.creator.ssCreator.tiktokAverages?.averageViews || 0) ) / 2
      } else if (this.creator.ssCreator.instagramAverages) {
        return (this.creator.ssCreator.instagramAverages?.averageViews || 0)
      } else if (this.creator.ssCreator.tiktokAverages) {
        return (this.creator.ssCreator.tiktokAverages?.averageViews || 0)
      } else {
        return 0
      }
    } else {
      return 0
    }
  }

  getAvgEngaegement() {
    if (this.creator && this.creator.ssCreator) {
      if (this.creator.ssCreator.instagramAverages && this.creator.ssCreator.tiktokAverages) {
        return ((this.creator.ssCreator.instagramAverages?.averageEngagementRate || 0) + (this.creator.ssCreator.tiktokAverages?.averageEngagementRate || 0) ) / 2
      } else if (this.creator.ssCreator.instagramAverages) {
        return (this.creator.ssCreator.instagramAverages?.averageEngagementRate || 0)
      } else if (this.creator.ssCreator.tiktokAverages) {
        return (this.creator.ssCreator.tiktokAverages?.averageEngagementRate || 0)
      } else {
        return 0
      }
    } else {
      return 0
    }
  }

  getFlag() {
    switch (this.creator && this.creator.countryCode) {
      case 'GB':
        return '🇬🇧';
      case 'US':
        return '🇺🇸';
      default:
        return '🇬🇧';
    }
  }
}
